import { Badge, Card, CardBody, Col, Container, Row, Spinner } from 'react-bootstrap';
import { Link } from '@/compat/react-router-dom';
import { useServicesPage } from '@/hooks/useServicesPage';

const WhoWeServe = ({ sectionData: propSectionData }) => {
  const { section: fetchedSection, loading, error } = useServicesPage('who_we_serve');
  const section = propSectionData || fetchedSection;

  if (loading && !propSectionData) {
    return (
      <section className="py-5 py-lg-6 bg-light services-section who-we-serve-section">
        <Container>
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Container>
      </section>
    );
  }

  if (error || !section || !section.is_active) {
    return null; // Don't render if section is inactive or error
  }

  const audiences = section.items || [];
  const bgColor = section.background_color || 'light';
  const bgEffect = section?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : 'bg-light';
  // Apply gradient effect if selected
  if (bgColor === 'primary' && bgEffect === 'gradient') {
    bgClass = 'section-bg-primary-gradient';
  }
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';

  return (
    <section className={`py-5 py-lg-6 ${bgClass} services-section who-we-serve-section ${hasDotsEffect ? 'position-relative overflow-hidden' : ''}`}>
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container className={hasDotsEffect ? 'position-relative' : ''}>
        <Row className="mb-4">
          <Col lg={8}>
            {section.subtitle && (
              <Badge bg="primary" className="bg-opacity-10 text-primary">
                {section.subtitle}
              </Badge>
            )}
            {section.title && (
              <h2 className="sec-title mb-3">{section.title}</h2>
            )}
            {section.intro_text && (
              <p className="lead intro-text" dangerouslySetInnerHTML={{ __html: section.intro_text }} />
            )}
          </Col>
        </Row>
        <Row className="g-4">
          {audiences.map((item, idx) => {
            const Icon = item.IconComponent;
            return (
              <Col key={item.id || idx} md={6} xl={3}>
                <Card className="h-100 border-0 shadow-sm card-hover-shadow">
                  <CardBody className="p-4 d-flex flex-column">
                    {Icon && (
                      <div className="icon-lg bg-white border rounded-circle text-primary flex-centered mb-3">
                        <Icon className="fs-4" />
                      </div>
                    )}
                    {item.title && <h5 className="mb-2 fw-bold">{item.title}</h5>}
                    {item.description && (
                      <p className="flex-grow-1" style={{ color: '#495057', lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: item.description }} />
                    )}
                    {item.link && (
                      <Link to={item.link} className="stretched-link text-decoration-none">
                        {item.link_text || 'Learn more →'}
                      </Link>
                    )}
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default WhoWeServe;

